import React from 'react'
import { Waypoint } from 'react-waypoint'
import { RootStore } from 'stores'
import styles from './styles.module.scss'
import { inject, observer } from 'mobx-react'

export interface PrimaryEmailCapWaypointProps {
	top: string
	rootStore?: RootStore
}

class PrimaryEmailCapWaypointComponent extends React.Component<PrimaryEmailCapWaypointProps> {
	private seconds = 3

	constructor(props) {
		super(props)
	}

	componentDidMount() {
		const secondsToTrigger = this.seconds
		const rootStore = this.props.rootStore!
		setTimeout(() => {
			rootStore.modalStore.modalEvent.run(rootStore.timerStore.pagesVisited)
		}, secondsToTrigger * 1000)
	}

	render() {
		const rootStore = this.props.rootStore!

		return (
			<div
				className={styles.waypoint}
				style={{ top: this.props.top }}
			>
				<Waypoint
					onEnter={() => {
						rootStore.modalStore.modalEvent.run(rootStore.timerStore.pagesVisited)
					}}
					scrollableAncestor={'window'}
				/>
			</div>
		)
	}
}

export const PrimaryEmailCapWaypoint = inject('rootStore')(observer(PrimaryEmailCapWaypointComponent))

export default PrimaryEmailCapWaypoint
